export const removeSplashScreen = () => {
    const splashElement = document.getElementById("splash");
    if (!!splashElement) {
        splashElement.remove();
    }
};
